module.exports = __webpack_public_path__ + "static/media/trolleybus.f2804c21.svg";